import { HttpClient, HttpContext } from '@angular/common/http';
import { UrlService } from '../../../../../../environments/urlService';
import { Injectable } from '@angular/core';
import { IS_SPINNER_ACTIVE } from '../../../../../util/interceptors';
import { StockDataMA } from '../dto/StockDataMA';
import { Observable } from 'rxjs';
import { ChartStockMA } from '../dto/ChartStockMA';
import { Sectors, TickerIndustriesDTO } from '../ma-tickers/sub/recovery-ticker-modal/recovery-ticker-modal.component';
import { StockNameTicker } from '../../../../company-performance/companies-stocks/dto/StockNameTicker';

@Injectable({
  providedIn: 'root',
})
export class MarketAnalysisTickerService {

  private readonly tickersMAUrl: string;
  private readonly tickersRecoveryUrl: string;

  constructor(private httpClient: HttpClient, private urlService: UrlService) {
    this.tickersMAUrl = this.urlService.getFmsUrl() + 'market-analysis/tickers';
    this.tickersRecoveryUrl = this.urlService.getFmsUrl() + 'recovery/ma/ticker';
  }

  public getMAStocksByCompany(): Observable<StockDataMA[]> {
    return this.httpClient.get<StockDataMA[]>(this.tickersMAUrl + '/ticker-list', {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
      responseType: 'json',
    });
  }

  public deleteTickerFromMA(tickerName: string): Observable<void> {
    return this.httpClient.delete<void>(this.tickersRecoveryUrl, {
      params: { tickerName },
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }

  public searchStocks(tickerPattern: string): Observable<StockNameTicker[]> {
    return this.httpClient.get<StockNameTicker[]>(this.tickersRecoveryUrl + '/search-api-pattern', {
      params: { tickerPattern },
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }

  public findMAInfoForModal(tickerName: string): Observable<StockDataMA> {
    return this.httpClient.get<StockDataMA>(this.tickersRecoveryUrl + '/search-ma-info', {
      params: { tickerName },
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }

  public addTickerToMA(tickerIndustriesDTO: TickerIndustriesDTO): Observable<void> {
    return this.httpClient.post<void>(this.tickersRecoveryUrl, tickerIndustriesDTO, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }

  public getChartMAData(): Observable<ChartStockMA[]> {
    return this.httpClient.get<ChartStockMA[]>(this.tickersMAUrl + '/avg', {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }

  public getFilteredChartMAData(stocksNames: string[]): Observable<ChartStockMA[]> {
    return this.httpClient.post<ChartStockMA[]>(this.tickersMAUrl + '/avg-filtered',
      stocksNames, {
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true,
      });
  }

  updateTickerIndustries(tickerIndustriesDTO: TickerIndustriesDTO): Observable<void> {
    return this.httpClient.put<void>(this.tickersRecoveryUrl, tickerIndustriesDTO, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }

  getAllFMSSectors(): Observable<Sectors[]> {
    return this.httpClient.get<Sectors[]>(this.tickersMAUrl + '/sectors-fms', {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }
}
